import { ItemThirdParty } from "./ItemThirdParty";

export default ItemThirdParty;